import { ONE_MILLION } from '../config'

export const convertToMillion = (value: number) => {
  return value / ONE_MILLION
}
